import { Component, Inject, Input } from "@angular/core";
import { ALERT_INBOX_GROUPS_TOKEN } from "@app2/alert/alert-inbox/injection-tokens";
import { FilterGroup, SortType, StateParams, StateType } from "@app2/fraud/type-defs";
import { RouterService } from "@app2/shared/services/router.service";

@Component({
    selector: "alert-state-filter",
    template: `
        <section class="sheet-side-menu-section">
            <ul *ngFor="let group of alertGroups;"
                class="sheet-side-menu no-list-styles">
                <h2>{{ group.name | localize }}</h2>
                <li *ngFor="let filter of group.filters"
                    class="sheet-side-menu-item click-target"
                    [class.active]="filter.key === selectedState"
                    (click)="selectState(filter.key)">
                    <a class="sheet-side-menu-item-text">
                        <i *ngIf="filter.key !== 'FRAUD_FLAGGED'; else renderSvg" class="{{ filter.icon }}"></i>
                        <ng-template #renderSvg>
                            <svg-icon src="assets/icons/fraudFlag.svg" class="flag-fraud-sidebar"
                                      [inline]="true"></svg-icon>
                        </ng-template>
                        {{ filter.key | localize }}
                    </a>
                </li>
            </ul>
        </section>
    `,
    styles: [`
        @import "/src/styles/colors";

        .sheet-side-menu-item {
            padding-left: 8px !important;
        }

        .sheet-side-menu-item-text {
            font-size: 0.75rem;
        }

        h2 {
            font-size: 1rem;
            line-height: 2.25rem;
        }
    `],
})
export class AlertStateFilterComponent {

    @Input() selectedState: StateType;

    constructor(@Inject(ALERT_INBOX_GROUPS_TOKEN) public alertGroups: FilterGroup[],
                private readonly router: RouterService) {
    }

    selectState(state: StateType) {
        if (this.selectedState === state) {
            return;
        }
        let sort: SortType;
        if (state === "ESCALATED") {
            sort = "last_escalated_desc";
        } else if (state === "DISMISSED") {
            sort = "last_dismissed_desc";
        } else if (state === "FRAUD_FLAGGED") {
            sort = "last_fraud_flagged_desc";
        } else {
            if (this.selectedState === "ESCALATED" || this.selectedState === "DISMISSED" || this.selectedState === "FRAUD_FLAGGED") {
                sort = "newest_first";
            }
        }
        this.router.mergeParams<StateParams>({
            state,
            ...(sort && { sort }), // Only updates sort field if it's defined
            selected: undefined,
        });
    }
}
